import GenericDB from './generic-db';

export default class DataNotesDB extends GenericDB {
  constructor() {
    super('dataNotes');
  }
}
